/**
 * Currency formatting utilities for the application
 * Currently supports Turkish Lira (TRY) only
 * Multi-currency support will be added in the future
 */

export const formatCurrency = (value: number | null | undefined, currency: string = 'TRY'): string => {
  if (value == null) return '-';
  
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

// For future multi-currency support
export const SUPPORTED_CURRENCIES = {
  TRY: {
    code: 'TRY',
    symbol: '₺',
    name: 'Turkish Lira',
    locale: 'tr-TR'
  }
  // USD: {
  //   code: 'USD', 
  //   symbol: '$',
  //   name: 'US Dollar',
  //   locale: 'en-US'
  // }
} as const;

export type SupportedCurrency = keyof typeof SUPPORTED_CURRENCIES;
export const DEFAULT_CURRENCY: SupportedCurrency = 'TRY';
